import React from 'react';
import styled, { css } from 'styled-components';
import { QRCodeSVG } from 'qrcode.react';
import { useLoyaltyPassImpressionTracking } from 'src/components/loyalty/use-loyalty-pass-impressions';
import { Typography } from 'src/typography';

type QRCodeProps = {
  url: string;
  size: number;
};

export const QRCode = ({ url, size }: QRCodeProps): JSX.Element => {
  const { ref } = useLoyaltyPassImpressionTracking({ type: 'qrCode' });
  return (
    <QrCodeContainer ref={ref}>
      <QRCodeSVG
        data-testid='loyalty-pass-qr-code'
        value={url}
        size={size}
        level='H'
        aria-label='QR code to add loyalty pass to Apple Wallet'
        imageSettings={{
          src: 'https://images.dutchie.com/pay/apple-wallet-icon.png',
          height: 48,
          width: 48,
          excavate: true,
        }}
      />
      <QRLabel id='loyalty-pass-instructions' size='small' tag='h3' weight='bold'>
        SCAN TO ADD PASS
      </QRLabel>
    </QrCodeContainer>
  );
};

const QrCodeContainer = styled.div`
  ${({ theme: { spaces, colors } }) => css`
    display: flex;
    padding: ${spaces[1]};
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${spaces[1]};
    border-radius: ${spaces[1]};
    border: 2.5px solid ${colors.grey[95]};
    background: ${colors.white};
  `}
`;

const QRLabel = styled(Typography.Heading)`
  ${({ theme: { colors } }) => css`
    color: ${colors.grey[30]};
    line-height: 28px;
  `}
`;
